import React, { useState } from "react";
import { form_add, buttonStyle } from "../../style/style";
import { FormControl, TextField, Button, Box } from "@mui/material";
import { validated } from "../../apicall/validateform";
import { postobj } from "../../apicall/apicall";
import NotificationContainer from "react-notifications/lib/NotificationContainer";
import NotificationManager from "react-notifications/lib/NotificationManager";
import { validateField } from "../../apicall/commonFunction";
import { dist_user } from "../../apicall/constants";

export default function AddDistributorUser(props) {
  const [user, setuser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    role: "DISTRIBUTOR-USER",
    id: props.id,
  });
  const [error, setError] = useState({});
  const handleChange = (e) => {
    const { value, name } = e.target;
    setuser({
      ...user,
      [name]: value,
    });
  };
  const validateForm = (data) => {
    let newErr = {};
    if (!data.first_name.trim()) {
      newErr.first_name = "First Name cannot be blank";
    }
    if (!data.last_name.trim()) {
      newErr.last_name = "Last Name cannot be blank";
    }
    if (!/^\d{1,10}$/.test(data.phone)) {
      newErr.phone = "Please enter a 10-digit phone number";
    }
    if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(data.email)) {
      newErr.email = "Please enter a valid email address";
    }
    let val = validateField(data, dist_user);
    if (Object.keys(val).length > 0) {
      Object.keys(val).forEach((field) => {
        console.log(field);
        newErr[field] = val[field];
      });
    }

    if (Object.keys(newErr).length > 0) {
      setError(newErr);
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    const validate = validateForm(user);
    if (
      validated(user) &&
      user["email"].includes("@") &&
      user["phone"].length <= 10 &&
      validate
    ) {
      e.preventDefault();
      let url = process.env.REACT_APP_ZEWA_URL + "user/add/0/";
      const d = postobj(url, user);
      d.then((response) => {
        console.log(response.status);
        if (response.status === 200) {
          return response;
        }
        throw new Error(response);
      })
        .then((res) => {
          //console.log(res);
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(res.Message);
          props.setadduser(false);
          props.setrefresh(!props.refresh);
        })
        .catch((err) => {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Email already registered");
        });
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error("Please fill the form correctly");
    }
  };

  return (
    <div style={{ padding: "10px", overflow: "hidden", margin: "10px" }}>
      <FormControl fullWidth>
        <TextField
          id="outlined-multiline-flexible"
          label="Enter first name"
          name="first_name"
          helperText={error.first_name ? error.first_name : ""}
          error={error.first_name || false}
          sx={form_add}
          value={user.first_name}
          onChange={(e) => {
            handleChange(e);
          }}
        />

        <TextField
          id="outlined-multiline-flexible"
          label="Enter last name"
          name="last_name"
          helperText={error.last_name ? error.last_name : ""}
          error={error.last_name || false}
          sx={form_add}
          value={user.last_name}
          onChange={(e) => {
            handleChange(e);
          }}
        />

        <TextField
          id="outlined-multiline-flexible"
          label="Enter user email"
          helperText={error.email ? error.email : ""}
          error={error.email || false}
          name="email"
          sx={form_add}
          value={user.email}
          onChange={(e) => {
            handleChange(e);
          }}
        />
        <TextField
          id="outlined-multiline-flexible"
          label="Enter phone number"
          helperText={error.phone ? error.phone : ""}
          error={error.phone || false}
          sx={form_add}
          value={user.phone}
          name="phone"
          onChange={(e) => {
            handleChange(e);
          }}
        />

        <Box m={1}>
          <Button
            variant="contained"
            color="primary"
            style={buttonStyle}
            onClick={(e) => {
              handleSubmit(e);
            }}
          >
            Add user
          </Button>
          <Button
            variant="contained"
            color="error"
            style={buttonStyle}
            onClick={(e) => {
              props.setadduser(false);
            }}
          >
            cancel
          </Button>
        </Box>
      </FormControl>
      <NotificationContainer />
    </div>
  );
}
